import moment from "moment";

import {
  START_CALL,
  UPDATE_CALL_STATE,
  RESET_CALL_STATE,
  TOGGLE_MUTE,
  START_ACW,
  TOGGLE_HOLD,
  INCOMING_CALL,
  WAITING_CALL,
  SET_GO_TO_ACW,
  SHOW_CONTACT_MODAL,
  UPDATE_STATECALL,
  SET_IS_CONSULTING,
  SET_IS_PARKING,
  SET_NEXT_ASSIGNMENT,
  SET_SELECTED_CALL_RECORD_ID,
  SET_IN_APP_CALL_STATUS,
  SET_IN_APP_CALL_TYPE,
  UPDATE_STATECALL_RECEIVED_DATE,
  CHECK_STRAY_CALL,
  END_ACW,
  SET_SCREEN_REC_FILENAME,
  SET_IS_CONTINUE_TRANSFER,
  SET_TRANSFER_COUNT,
} from "../Types/CallTypes";

const callState = {
  stateCall: {},
  isInCall: false,
  phoneNumber: "",
  stateCode: "",
  onHold: false,
  isMuted: false,
  goToACW: false,
  isInACW: false,
  ACDDeviceName: "",
  queueName: "",
  ext: "",
  contactID: "",
  callWaiting: null,
  type: "",
  showContactModal: false, // to trigger useEffect on contact page, showing contact modal
  isConsulting: false,
  isParking: false,
  campaignID: null,
  phoneTypeID: null,
  callTime: "",
  startNextAssignment: false, // For auto dial, to show overlay,
  selectedCallRecordID: null, // To show call history, from dashboard
  ACWMode: "", // Mode for acw-timeout
  ACWDuration: "", // Timeout time
  inAppCallStatus: "", // For in-app call
  inAppCallType: "", // For in-app call
  isTelemarketing: null,
  screenRecFilename: "",
  isContinueTransfer: null, // For in-app video call transfer, to decide when to merge recordings
  transferCount: 0, // For in-app video call transfer, to count recording parts
};

const initialState = JSON.parse(JSON.stringify(callState));

export const callReducer = (state = callState, action) => {
  const { payload, type } = action;

  if (type === START_CALL) {
    return {
      ...state,
      isInCall: payload.type === "inbound" ? false : true,
      phoneNumber: payload.phoneNumber,
      goToACW: payload.goToACW,
      contactID: payload.contactID,
      type: payload.type,
      campaignID: payload.campaignID,
      phoneTypeID: payload.phoneTypeID,
      callTime: moment(),
      stateCode: payload.stateCode,
      ACWMode: payload.ACWMode,
      ACWDuration: payload.ACWDuration,
      isTelemarketing: payload.isTelemarketing
    };
  }

  if (type === UPDATE_STATECALL) {
    return {
      ...state,
      stateCall: payload,
    };
  }

  if (type === UPDATE_STATECALL_RECEIVED_DATE) {
    return {
      ...state,
      stateCall: { ...state.stateCall, receivedDate: payload },
    };
  }

  if (type === UPDATE_CALL_STATE) {
    return {
      ...state,
      stateCode: payload.stateCode,
      phoneNumber: payload.phoneNumber
        ? payload.phoneNumber
        : state.phoneNumber,
    };
  }

  if (type === TOGGLE_HOLD) {
    return {
      ...state,
      onHold: !state.onHold,
    };
  }

  if (type === TOGGLE_MUTE) {
    return {
      ...state,
      isMuted: payload.isMuted,
    };
  }

  if (type === START_ACW) {
    return {
      ...state,
      stateCode: "",
      isInACW: true,
    };
  }

  if (type === RESET_CALL_STATE) {
    state = initialState;
    return { ...state };
  }

  if (type === INCOMING_CALL) {
    return {
      ...state,
      ACDDeviceName: payload.ACDDeviceName ?? state.ACDDeviceName,
      queueName: payload.queueName ?? state.queueName,
      ext: payload.ext ?? state.ext,
      contactID: payload.contactID ?? state.contactID,
      phoneNumber: payload.phoneNumber ?? state.phoneNumber,
      phoneTypeID: payload.phoneTypeID ?? state.phoneTypeID,
      type: payload.type ?? state.type,
    };
  }

  if (type === WAITING_CALL) {
    return {
      ...state,
      callWaiting: payload.callWaiting,
      ACDDeviceName: payload.ACDDeviceName,
    };
  }

  if (type === SET_GO_TO_ACW) {
    return {
      ...state,
      goToACW: payload,
    };
  }

  // To trigger useEffect on contact page
  if (type === SHOW_CONTACT_MODAL) {
    return {
      ...state,
      showContactModal: !state.showContactModal,
    };
  }

  if (type === SET_IS_CONSULTING) {
    return {
      ...state,
      isConsulting: payload,
    };
  }

  if (type === SET_IS_PARKING) {
    return {
      ...state,
      isParking: payload,
    };
  }

  // To trigger useEffect on call overlay
  if (type === SET_NEXT_ASSIGNMENT) {
    return {
      ...state,
      startNextAssignment: payload,
    };
  }

  if (type === SET_SELECTED_CALL_RECORD_ID) {
    return {
      ...state,
      selectedCallRecordID: payload,
    };
  }

  if (type === SET_IN_APP_CALL_STATUS) {
    return {
      ...state,
      inAppCallStatus: payload,
    };
  }

  if (type === SET_IN_APP_CALL_TYPE) {
    return {
      ...state,
      inAppCallType: payload,
    };
  }

  if (type === CHECK_STRAY_CALL && !state.isInCall) {
    return {
      ...state,
      isInCall: true,
      goToACW: payload.goToACW,
      type: "inbound",
      phoneTypeID: payload.phoneTypeID,
      callTime: moment(),
    };
  }

  if (type === END_ACW) {
    return {
      ...state,
      isInACW: false,
    };
  }

  if (type === SET_SCREEN_REC_FILENAME) {
    return {
      ...state,
      screenRecFilename: payload,
    };
  }

  if (type === SET_IS_CONTINUE_TRANSFER) {
    return {
      ...state,
      isContinueTransfer: payload,
    };
  }

  if (type === SET_TRANSFER_COUNT) {
    return {
      ...state,
      transferCount: payload,
    };
  }

  return state;
};
